import React from 'react'
import styled from '@emotion/styled'
import { PAGE_BREAKPOINTS } from 'parameters/index'
import { AdvertiserDisclosure } from 'components/content'

export const ResultListTitle = (): JSX.Element => {
	return (
		<ListTop>
			<ListTitle>Example Refinance Options</ListTitle>
			<Advert>
				<AdvertiserDisclosure />
			</Advert>
		</ListTop>
	)
}

const ListTop = styled.div`
	display: flex;
	justify-content: space-between;
	@media screen and (${PAGE_BREAKPOINTS.MOBILE}) {
		flex-direction: column;
		margin-top: 24px;
	}
`

const ListTitle = styled.span`
	font-size: 18px;
	font-weight: bold;
`

const Advert = styled.div`
	display: flex;
	align-items: center;
	@media screen and (${PAGE_BREAKPOINTS.MOBILE}) {
		margin-top: 16px;
	}
	span {
		font-size: 14px;
		color: #bdc4c9;
		margin-left: 4px;
	}
`
